import { useEffect } from 'react';
import * as Analytics from '../Services/Analytics.service';

const PurchaseTracker = ({ order }) => {
  useEffect(() => {
    if (order?.transaction_id) {
      Analytics.trackPurchase(order);
    }
  }, [order]);

  return null;
};

export default PurchaseTracker;
